import { ROLL_FORWARD_WIZARD_FLAG_KEY } from "../roll_forward_wizard.constants";

// TODO: [SP-12116] remove the roll_forward_wizard flag hook when the Roll Forward Wizard epic is ready
export const useIsRollForwardWizardEnabled = (): boolean =>
  localStorage.getItem(ROLL_FORWARD_WIZARD_FLAG_KEY) === "true";
